import { PDF_PAGE_CSS, PDF_TOOLBAR_HTML, wireDocWindow } from './pdfPage';

export const emptyOfferPos = () => ({ beschreibung: '', menge: 1, preis: '' });

export const EMPTY_OFFER_DATA = {
    titel: '',
    kundenname: '',
    adresse: '',
    anforderungen: '',
    design: '',
    positionen: [emptyOfferPos()],
    mwst: 0,
    gueltigBis: '',
};

const escHtml = (v) => String(v ?? '').replace(/[&<>"']/g, (c) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
}[c]));

export function buildOfferHTML({ nummer, datum, gueltigBis, kundenname, adresse, titel, anforderungen, design, positionen, mwst }) {
    nummer = escHtml(nummer);
    datum = escHtml(datum);
    gueltigBis = escHtml(gueltigBis);
    kundenname = escHtml(kundenname);
    adresse = escHtml(adresse);
    titel = escHtml(titel);
    const netto = (positionen || []).reduce((sum, p) => sum + (parseFloat(p.preis) || 0) * (parseFloat(p.menge) || 0), 0);
    const mwstBetrag = netto * (mwst / 100);
    const gesamt = netto + mwstBetrag;
    const rows = (positionen || []).map((p, i) => `
        <tr>
            <td style="padding:10px 12px;border-bottom:1px solid #e5e7eb;">${i + 1}</td>
            <td style="padding:10px 12px;border-bottom:1px solid #e5e7eb;">${escHtml(p.beschreibung) || '—'}</td>
            <td style="padding:10px 12px;border-bottom:1px solid #e5e7eb;text-align:center;">${escHtml(p.menge)}</td>
            <td style="padding:10px 12px;border-bottom:1px solid #e5e7eb;text-align:right;">${(parseFloat(p.preis) || 0).toFixed(2)} €</td>
            <td style="padding:10px 12px;border-bottom:1px solid #e5e7eb;text-align:right;font-weight:600;">${((parseFloat(p.preis) || 0) * (parseFloat(p.menge) || 0)).toFixed(2)} €</td>
        </tr>`).join('');

    return `<!DOCTYPE html><html lang="de"><head><meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Angebot ${nummer}</title>
    <style>
        ${PDF_PAGE_CSS}
        .logo{font-family:Georgia,'Times New Roman',serif;font-size:22px;font-weight:700;color:#1a1a1a;letter-spacing:-0.3px;margin-bottom:2px;}
        .subtitle{font-size:10px;letter-spacing:.12em;text-transform:uppercase;color:#aaa;margin-bottom:28px;}
        .header{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:24px;}
        .meta{text-align:right;font-size:13px;color:#555;line-height:1.9;}
        .meta strong{color:#111;}
        .to{margin-bottom:24px;}
        .to .label{font-size:10px;text-transform:uppercase;letter-spacing:.1em;color:#aaa;margin-bottom:5px;}
        .to .name{font-size:16px;font-weight:700;}
        .to .addr{font-size:13px;color:#555;margin-top:3px;white-space:pre-line;}
        h1{font-size:19px;font-weight:800;margin-bottom:16px;}
        h2{font-size:13.5px;font-weight:800;margin:22px 0 6px;padding-top:10px;border-top:1px solid #e5e7eb;}
        p{margin-bottom:6px;color:#222;orphans:3;widows:3;white-space:pre-line;}
        .section{page-break-inside:avoid;break-inside:avoid-page;}
        table{width:100%;border-collapse:collapse;margin-bottom:20px;}
        thead tr{background:#f9fafb;}
        thead th{padding:10px 12px;text-align:left;font-size:11px;text-transform:uppercase;letter-spacing:.06em;color:#888;border-bottom:2px solid #e5e7eb;}
        thead th:last-child,thead th:nth-last-child(2){text-align:right;}
        thead th:nth-child(3){text-align:center;}
        .totals{margin-left:auto;width:280px;page-break-inside:avoid;break-inside:avoid-page;}
        .totals tr td{padding:7px 12px;font-size:14px;}
        .totals tr td:last-child{text-align:right;font-weight:600;}
        .total-row td{font-size:17px;font-weight:800;border-top:2px solid #111;padding-top:12px;color:#1a1a1a;}
        .valid-note{margin-top:24px;padding:12px 16px;background:#f4f4f5;border-left:3px solid #1a1a1a;border-radius:6px;font-size:12.5px;color:#3f3f46;line-height:1.6;page-break-inside:avoid;break-inside:avoid-page;}
        .valid-note strong{color:#18181b;}
    </style></head><body>
    ${PDF_TOOLBAR_HTML}
    <div class="page-wrap">
    <div id="doc-content">
    <div class="header">
        <div>
            <div class="logo">&lt;MiS/&gt;</div>
            <div class="subtitle">Make it Simple</div>
        </div>
        <div class="meta">
            <div><strong>Angebot ${nummer}</strong></div>
            <div>${datum || '—'}</div>
            ${gueltigBis ? `<div>Gültig bis: ${gueltigBis}</div>` : ''}
        </div>
    </div>
    <div class="to">
        <div class="label">Angebot für</div>
        <div class="name">${kundenname || '—'}</div>
        ${adresse ? `<div class="addr">${adresse}</div>` : ''}
    </div>
    <h1>${titel || 'Angebot'}</h1>

    ${anforderungen ? `<div class="section"><h2>Anforderungen &amp; Funktionsumfang</h2><p>${anforderungen}</p></div>` : ''}
    ${design ? `<div class="section"><h2>Design</h2><p>${design}</p></div>` : ''}

    <div class="section">
    <h2>Kalkulation</h2>
    <table>
        <thead><tr>
            <th style="width:40px;">#</th>
            <th>Beschreibung</th>
            <th style="width:70px;text-align:center;">Menge</th>
            <th style="width:110px;text-align:right;">Einzelpreis</th>
            <th style="width:110px;text-align:right;">Gesamt</th>
        </tr></thead>
        <tbody>${rows}</tbody>
    </table>
    <table class="totals">
        <tr><td>Netto</td><td>${netto.toFixed(2)} €</td></tr>
        ${mwst > 0 ? `<tr><td>MwSt. ${mwst}%</td><td>${mwstBetrag.toFixed(2)} €</td></tr>` : ''}
        <tr class="total-row"><td>Gesamt</td><td>${gesamt.toFixed(2)} €</td></tr>
    </table>
    ${mwst === 0 ? '<p style="font-size:12px;color:#888;">Gemäß § 19 UStG wird keine Umsatzsteuer berechnet.</p>' : ''}
    </div>

    <div class="valid-note">
        Dieses Angebot ist die Grundlage für § 1 (Vertragsgegenstand) des Dienstleistungsvertrags und wird bei Beauftragung dessen Bestandteil.
        ${gueltigBis ? `Es ist gültig bis <strong>${gueltigBis}</strong>.` : ''}
    </div>
    </div>
    </div>
    <script src="${window.location.origin}/tools/html2pdf.bundle.min.js"></script>
    </body></html>`;
}

export function wireOfferWindow(win, dateiname) {
    wireDocWindow(win, dateiname || 'Angebot', ['.section', '.totals', '.valid-note']);
}
